module.exports = __webpack_public_path__ + "resources/img/main08_m.5db6dd508043c54da07a36fe1607bd89.jpg";